import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ChatbotResultType, useGetAnswersMutation } from '../store/services/chatservice';
import { selectEmail, selectFarmChatLastId, setQuestions } from '../store/features/chatbotSlice';

export const useFarmChatbot = () => {
	const location = useLocation()
	const dispatch = useDispatch()
	let [getAnswers] = useGetAnswersMutation<ChatbotResultType>()
	const email = useSelector(selectEmail)
	const divId = useSelector(selectFarmChatLastId)
	const key = location.pathname.replace('/', '')

	const queryFarmChatbot = async (query: string | null) => {
		if (!query) return

		dispatch(setQuestions({key, value: query}))

		getAnswers({ email, query })
		if (divId) {
			setTimeout(() => {
				document.getElementById(divId)?.scrollIntoView({
					behavior: "smooth",
					block: "end",
					inline: "nearest"
				});
			}, 2000)
		}
	}

	return { queryFarmChatbot }
}
